<template>
  <div class="surface-post-actions" :data-theme="theme">
    <div v-if="showIconList" class="actions-icon-list">
      <button
        v-if="isEditableByCurrentUser"
        class="icon-button-inverse actions-edit"
        @click="editPost"
        v-t:title="'Edit post'"
      >
        <base-icon name="edit" />
      </button>
      <button
        v-if="isEditableByCurrentUser"
        class="icon-button-inverse actions-delete"
        @click="deletePost"
        v-t:title="'Delete post'"
      >
        <base-icon name="delete" />
      </button>
      <button class="icon-button-inverse actions-more" @click="toggleDropdown" v-t:title="'More actions'">
        <base-icon v-if="isEditableByCurrentUser" name="more_horiz" />
        <base-icon v-if="!isEditableByCurrentUser" name="more_vert" />
      </button>
    </div>
    <button v-else class="actions-dropdown icon-button" @click="toggleDropdown" v-t:title="'Post actions'">
      <base-icon name="more_vert" />
    </button>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import IntlMixin from 'vuemixins/intl_mixin'
import { mapActions, mapState } from 'vuex'
export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['post', 'colorScheme', 'attachmentLuminance', 'isEditableByCurrentUser', 'isBeingEdited', 'xAuthor'],
  computed: {
    ...mapState(['isTouchable']),
    theme() {
      const backgroundIsAttachment = !(this.xAuthor || this.post.subject || this.post.body)
      return backgroundIsAttachment ? this.attachmentLuminance : this.colorScheme
    },
    showIconList() {
      return !this.isTouchable || this.isBeingEdited
    },
  },
  methods: {
    editPost() {
      this.$emit('edit')
    },
    deletePost() {
      this.$emit('delete')
    },
    toggleDropdown() {
      this.$emit('dropdown')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';

.surface-post-actions {
  .actions-icon-list {
    display: none;
    position: absolute;
    top: -24px;
    right: 8px;
    border-radius: $double-border-radius;
    background-color: $neutral-color;
    color: $inverse-caption-text-color;
    padding: 0px 6px;

    //show on wish edit. hide edit option, though.
    [data-view-mode='edit'] & {
      display: flex;

      .actions-edit,
      .actions-more {
        display: none;
      }
    }

    .free [data-view-mode='edit'] &,
    .grid [data-view-mode='edit'] & {
      top: -16px;
      right: 16px;
    }

    //show on wish view hover
    .mousable [data-view-mode='show']:hover & {
      display: flex;
    }

    .icon-button-inverse {
      padding: 7px 3px;
      color: $inverse-muted-text-color;

      i {
        font-size: 18px;
      }

      &:hover {
        color: $inverse-body-text-color;
      }
    }
  }
}

.wish-connectable {
  .surface-post-actions,
  .surface-post-actions:hover {
    display: none;
  }
}

.surface-post-actions {
  .actions-dropdown {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    overflow: hidden;

    & > i {
      position: absolute;
      top: 4px;
      right: -3px;
    }
  }

  &[data-theme='dark'] {
    .icon-button {
      color: $inverse-caption-text-color;

      &:hover {
        color: $inverse-body-text-color;
      }
    }
  }

  &[data-theme='light'] {
    .icon-button {
      color: $caption-text-color;

      &:hover {
        color: $body-text-color;
      }
    }
  }
}
</style>
